module.exports = __webpack_public_path__ + "assets/55eb885da7b673505eb363039fea4075.svg";